import React from 'react'
import { Link } from 'react-router'
import { Modal } from 'hljd'
import { corpImage } from '@components/Hotel/util'
import { VR_VERIFY_FAIL } from '@components/Hotel/constant'
import { VR_STATUS_LIST } from './constant'
import store from './store'
import styles from './index.module.less'
import { VR_INFO_PATH } from '@constant'

const defaultCover = 'https://qnm.hunliji.com/o_1d4k5mimi1bll6ru61gppe17sb9.png'

export default [
  {
    title: '全景图信息',
    key: 'vr_info',
    render(data) {
      const { cover, name, scene_num, is_done } = data
      return (
        <div className={styles['vr-info']}>
          <div className={styles['cover-wrap']}>
            <img
              className={styles.cover}
              src={corpImage(cover || defaultCover, '16:9', 100)}
              alt={name}
            />
            {+is_done !== 1 && <div className={styles['mask']}>制作中</div>}
          </div>
          <div className={styles.info}>
            <div className={styles['site-name']}>{name}</div>
            <div className={styles['scene-num']}>场景数量: {scene_num}</div>
          </div>
        </div>
      )
    }
  },
  {
    title: '关联场地',
    key: 'linked_site',
    render: ({ hotel_hall_name }) => (
      <div style={{ fontSize: 14 }}>{hotel_hall_name || '-'}</div>
    )
  },
  {
    title: '审核状态',
    key: 'status',
    render({ status, reason }) {
      return (
        <div style={{ fontSize: 14 }}>
          <div>{VR_STATUS_LIST[status]}</div>
          {status + '' === VR_VERIFY_FAIL && (
            <span
              onClick={() => {
                Modal.info({
                  content: reason
                })
              }}
              style={{ cursor: 'pointer', color: '#448afc' }}
            >
              查看原因
            </span>
          )}
        </div>
      )
    }
  },
  {
    title: '上传时间',
    key: 'create_at',
    render: ({ created_at = '' }) => (
      <div style={{ fontSize: 14 }}>
        {created_at.replace(/\s(\d+:){2}\d+/, '').replace(/-/g, '.')}
      </div>
    )
  },
  {
    title: '操作',
    key: 'do',
    render({ id, is_done }, _, i) {
      return (
        <div style={{ fontSize: 14 }}>
          {+is_done === 1 && (
            <Link
              to={`${VR_INFO_PATH}?id=${id}`}
              style={{ marginRight: 20, color: '#448afc' }}
            >
              编辑
            </Link>
          )}
          <a
            onClick={() => store.deleteVrInfo(id)}
            style={{ color: '#FF705E', cursor: 'pointer' }}
          >
            删除
          </a>
        </div>
      )
    }
  }
]
